module.exports = __webpack_public_path__ + "static/media/icon_lpr.d370b3d7.png";